<div class="edit-box">
  <header [hidden]="headerText == ''">
    <label>{{headerText}}</label>
  </header>
  <ul class="hidden-list" [hidden]="labels.length<2 ">
    <li *ngFor="let label of labels">
      <core-label-action [label]="label" (actionClick)="remove($event)"></core-label-action>
    </li>
  </ul>

  <core-labels-list [hidden]="labels.length>1" [labels]="labels"></core-labels-list>


  <!-- search box -->
  <app-helpers-labels-search-box
    [allowClose]="allowClose"
    [placeholder]="searchPlaceholder"
    [foundText]="searchFoundText"
    [add]="addControl && access.access_label_add"
    (choose)="add($event)"
    (close)="close.emit($event)"
    [(input)]="input"
  ></app-helpers-labels-search-box>
</div>
